import React from 'react'
import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import bgLogin from '../assets/img/bg-login.jpg'
import { Outlet } from 'react-router-dom'

const Home = () => {
   return (
      <Box>
         <Grid
            className="login-container"
            container
            spacing={0}
            sx={{ display: 'flex', alignItems: 'center', height: '100vh' }}
         >
            <Grid item xs={12} md={6} lg={6} className="left-bg" sx={{ position: 'relative', height: '100vh', width: '100%' }}>
               <img
                  alt="Page loading..."
                  src={bgLogin}
                  style={{
                     position: 'absolute',
                     top: 0,
                     left: 0,
                     width: '100%',
                     height: '125%',
                     objectFit: 'cover',
                  }}
               />
            </Grid>
            <Outlet />
         </Grid>
      </Box>
   )
}
export default Home
